export const copy = {
  access: {
    loading: 'Loading…',
    notFound: 'Page not found',
    deadLink: 'This link no longer works',
    codeSent: (maskedEmail: string) => `Code sent to ${maskedEmail}`,
    formLabel: 'Verify report access code',
    codeLabel: 'Enter the code',
    submit: 'Continue',
    wrongCode: 'Wrong code',
    sessionExpired: 'Session expired',
    throttled: 'Too many attempts',
    unrecognizedScope: 'Unsupported report',
    unreachable: 'Could not check this link',
    reportUnreachable: 'Could not load the report',
    retry: 'Try again',
  },
  report: {
    title: 'Daily Patient Escalation Report',
    period: (start: string, end: string) => `${start} – ${end}`,
    dailyOverview: {
      title: 'Daily Overview',
      metric: 'Metric',
      count: 'Count',
      interactions: 'Interactions',
      patientsEngaged: 'Patients Engaged',
      evaluationsTriggered: 'Evaluations Triggered',
      evaluationsCompleted: 'Evaluations Completed (Clinical Review)',
      patientsEscalated: (workspace: string) => `Patients Escalated to Provider (${workspace})`,
      patientsUrgentlyEscalated: 'Patients Requiring Emergent/Urgent/Immediate Escalation',
    },
    tables: {
      urgentTitle: 'Patients Requiring Emergent/Urgent/Immediate Escalation',
      routineTitle: 'Patients Requiring Routine Escalations',
      patientRequestsTitle: 'Patient Requests',
      patientInteractionsTitle: 'Patient Interactions',
      number: '#',
      patient: 'Patient',
      dateOfBirth: 'DOB',
      provider: 'Provider',
      recommendation: 'Recommendation',
      empty: 'No patients in this category.',
      missing: '—',
    },
    recommendation: {
      emergent: 'Emergent',
      urgent: 'Urgent',
      immediate: 'Immediate',
      routine: 'Routine',
      emergentText: 'Recommended ED visit',
      visitBy: (date: string) => `Needs visit by ${date}`,
      urgentFallback: 'Recommend visit within 48 hours',
      immediateFallback: 'Recommend visit between 3-7 days',
      routineFallback: 'Recommend visit between 8-30 days',
      category: (level: string, description: string) => `${level} Evaluation - ${description}`,
    },
    patientInformation: {
      title: 'Patient Information',
      name: 'Name',
      dateOfBirth: 'DOB',
      phoneNumber: 'Phone Number',
      provider: 'Provider',
    },
    systemEscalation: {
      title: 'System Escalation',
      date: 'Date and Time',
      reason: 'Reason for Escalation',
    },
    careManagerEscalation: {
      title: 'Care Manager Escalation',
      date: 'Date and Time',
      careManagerName: 'Care Manager',
      urgency: 'Urgency',
      request: 'Escalation Information/Request',
    },
  },
} as const
